// Lightweight haptic feedback wrapper.
//
// Uses the Web Vibration API (navigator.vibrate). Works on Android Chrome
// (and Chromium-based mobile browsers) but is a no-op on iOS Safari — Apple
// disabled it for fingerprinting-prevention reasons. Once the Capacitor
// shell ships in v1.1, swap the body of `pulseHaptic` for the
// @capacitor/haptics native API which works on both platforms.
//
// Intent (semantic levels) instead of raw ms so the call sites read cleanly
// and we can tune all four in one place.

export type HapticIntent = 'light' | 'medium' | 'heavy' | 'warning';

const PATTERNS: Record<HapticIntent, number[]> = {
  light:   [30],
  medium:  [60],
  heavy:   [120],
  // Two short pulses — distinctive, signals "attention required."
  warning: [80, 50, 80],
};

export function pulseHaptic(intent: HapticIntent = 'medium'): void {
  if (typeof navigator === 'undefined') return;
  const nav = navigator as Navigator & { vibrate?: (p: number[]) => boolean };
  if (typeof nav.vibrate !== 'function') return;
  try {
    nav.vibrate(PATTERNS[intent]);
  } catch {
    // Quietly swallow — vibration permission can be revoked or the API can
    // throw under iframe/sandboxed contexts. Not worth surfacing.
  }
}
